<script lang="ts">
  import type {Suggestion} from "../../../generated";
  import {SqrlQaId} from "../../../constants/squirrel";
  import ModifiedArrowButton from "../../interactive/ModifiedArrowButton.svelte";
  import {activeIndex} from "../../../store/IndexStore";
  import {SUBMIT_TYPE, submitStore} from "../../../store/SubmitStore";
  import {timeSuggest} from "../../../times/TimeFactory";

  export let index: number;
  export let suggestion: Suggestion;

  function handleSubmit() {
    timeSuggest.measure();
    submitStore.handleSubmit(suggestion.term, suggestion.target, SUBMIT_TYPE.SUGGEST_ITEM);
  }
</script>

<li class="squirrel_searchSuggest"
    data-qa-id={SqrlQaId.SUGGEST_ITEM}
    data-testid="suggestion-{index}">
    <div class="pl_table-view--item-fully-clickable">
        <div class="squirrel_searchSuggest__text js_squirrel_searchSuggest"
             data-qa-id={SqrlQaId.SUGGEST_ROW}>
      <span class="pl_copy100 squirrel_searchSuggest__term js_squirrel_searchSuggest__term"
            class:squirrel_active={index === $activeIndex}
            data-target={suggestion.target}
            data-term={suggestion.term}
            data-pos={index}
            data-suggestpos={index+1}
            on:click|preventDefault={handleSubmit}
            on:keydown
            role="button">{@html suggestion.visual}</span>
            <ModifiedArrowButton on:sendRequest term={suggestion.term} index={index}/>
        </div>
    </div>
</li>

<style lang="scss">
  @use "~@otto-ec/global-frontend-settings/scss/pl_variables" as pl_variables;
  @use "~@otto-ec/global-frontend-settings/scss/font-size" as fonts;
  @use "~@otto-ec/global-frontend-settings/scss/variables" as variables;

  .squirrel_active {
    color: pl_variables.$pl_color-red100;
  }

  .squirrel_searchSuggest {
    position: relative;
    cursor: pointer;
    background-color: white;
    padding: 0 16px;

    &:hover {
      background-color: pl_variables.$pl_color-grey25;
    }

    &:not(:last-child) {
      > div {
        border-bottom: 1px solid pl_variables.$pl_color-grey25;
      }
    }

    &:last-child {
      border-radius: 0 0 8px 8px;

      > div {
        border-bottom: none;
      }
    }

    &__text {
      @include fonts.font-size(variables.$font100, false);

      padding: 12px 0;
      display: flex;
      height: 48px;

      > .squirrel_searchSuggest__term {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 40px;
        width: 100%;
      }
    }
  }
</style>
